export default function processTitleHtml(titleHtml) {
    const parser = new DOMParser();
    const dom = parser.parseFromString(titleHtml.__html, 'text/html');
    for (const element of dom.querySelectorAll('[style*="text-align"]')) {
        if (!(element instanceof HTMLElement)) {
            continue;
        }
        const textAlign = element.style.textAlign;
        if (textAlign === 'left') {
            element.style.textAlign = 'start';
        }
        else if (textAlign === 'right') {
            element.style.textAlign = 'end';
        }
    }
    return { __html: dom.body.innerHTML };
}
